@import "@/styles/variables";

.pageContent {
	padding: 0 0.7rem 1rem;
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
}

.customerCard {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 1rem;
	flex-wrap: wrap;
	padding: 0.875rem 1rem;
	border: 1px solid $gray-200;
	border-radius: 12px;
	background: #ffffff;
}

.customerMain {
	display: flex;
	align-items: center;
	gap: 1rem;
	flex: 1;
	min-width: 0;
}

.logoContainer {
	width: 72px;
	height: 72px;
	flex-shrink: 0;
	cursor: pointer;
	border-radius: 10px;
	overflow: hidden;
	border: 1px dashed $gray-300;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: border-color 0.2s ease;

	&:hover {
		border-color: $primary-color;
	}
}

.logo {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.customerInfo {
	display: flex;
	flex-direction: column;
	gap: 0.2rem;
	min-width: 0;
}

.customerName {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
	color: $gray-700;
}

.customerHint {
	margin: 0;
	font-size: 0.75rem;
	color: $gray-500;
}

.excelSection {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding-left: 1rem;
	border-left: 1px solid $gray-200;
	min-width: 260px;
	max-width: 360px;

	@media (max-width: 768px) {
		width: 100%;
		max-width: none;
		padding-left: 0;
		padding-top: 0.75rem;
		border-left: none;
		border-top: 1px solid $gray-200;
	}
}

.excelInfo {
	display: flex;
	flex-direction: column;
	gap: 0.2rem;
}

.excelTitle {
	font-size: 0.875rem;
	font-weight: 600;
	color: $gray-700;
}

.excelHint {
	margin: 0;
	font-size: 0.75rem;
	line-height: 1.35;
	color: $gray-500;
}

.excelActions {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
}
